export default __webpack_public_path__ + "static/loop-e4cb2bbbca2009d202d6517ec79c0364.mp4";